import Vue from 'vue'
import Router from 'vue-router'


const Login = () => import('@/pages/login');
const AppNav = () => import('@/components/AppNav');
const Register = () => import('@/pages/register');
const forgetPassword = () => import('@/pages/forgetPassword');

import iView from 'iview';
import myProfile from '@/pages/myProfile/route';
import index from '@/pages/index/route'
import financingManagement from '@/pages/financingManagement/route'
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      // redirect:'/login',
      component:Login,
      name:'login'
    },
    {
      path: '/register',
      // redirect:'/login',
      component: Register,
      name:'register'
    },
    {
      path: '/forgetPassword',
      component: forgetPassword,
      name:'forgetPassword'
    },
    {
      path: '/',
      component: AppNav,
      children: [
        myProfile,
        index,
        financingManagement
      ]
    },
  ]
});



router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  if (!sessionStorage.getItem('currentUser') && to.name !== 'login'&&to.name!=='register'&&to.name!=='resetPassword'&&to.name!=='forgetPassword') { // 判断是否已经登录且前往的页面不是登录页
    next({
      name: 'login'
    });
  } else {
    if (sessionStorage.getItem('currentUser') && to.name === 'login') {

    }
    next();
  }
});


router.afterEach((to) => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js